// Context + hook pro Magic control bridge — oddělené od komponenty MagicControlBridge,
// aby soubor s komponentou exportoval jen komponentu (React Fast Refresh).

import { createContext, useContext } from 'react';

export interface MagicControlBridgeContextValue {
  /** Pošle Magic control instanci, že uživatel kliknul na konkrétní menu item. */
  readonly sendMenuItemClick: (menuItemId: string) => void;
  /** Univerzální postMessage send Magic control iframu. */
  readonly send: (action: string, data?: Record<string, unknown>) => void;
  /** Pošle do konkrétního legacy form iframu (podle layerId) signál pro close. */
  readonly sendCloseToLegacyForm: (layerId: string) => void;
  /**
   * Naviguje control iframe na Magic logout URL (vyčistí Magic FormsAuth cookie) a vyřeší se,
   * jakmile se logout stránka načte (s 3s pojistkou). Volá `UserAccountMenu` před `signOut()`.
   */
  readonly logoutMagic: (logoutUrl: string) => Promise<void>;
}

export const MagicControlBridgeContext = createContext<MagicControlBridgeContextValue | null>(null);

export function useMagicControlBridge(): MagicControlBridgeContextValue {
  const ctx = useContext(MagicControlBridgeContext);
  if (!ctx) {
    throw new Error(
      'useMagicControlBridge must be used inside <MagicControlBridge> — check Phoenix-On-Top mode is enabled'
    );
  }
  return ctx;
}
